import Button from "@mui/material/Button";
import { ReactComponent as IconSecurity } from "../../images/iconSecurity.svg";

export const colunasConsultas = [
  { field: "id", headerName: "ID", width: 0, hide: true },
  {
    field: "especialidade",
    headerName: "Especialidade",
    headerClassName: "color-blue",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "profissionalResponsavel",
    headerName: "Profissional responsável",
    editable: true,
    headerClassName: "color-blue",
    flex: 2,
    minWidth: 170,
  },
  {
    field: "unidadeDeSaude",
    headerName: "Unidade de saúde",
    headerAlign: "left",
    align: "left",
    headerClassName: "color-blue",
    flex: 3,
    minWidth: 250,
  },
  {
    field: "criadoEm",
    headerName: "Data da consulta",
    editable: true,
    headerClassName: "color-blue",
    flex: 1.2,
    minWidth: 120,
  },
  {
    field: "acoes",
    headerName: "Ações",
    width: 140,
    description: "This column has a value getter and is not sortable.",
    headerClassName: "color-blue",
    sortable: false,
    renderCell: (params) => {
      const onClick = (e) => {
        const currentRow = params.row;

        window.location.href = `/pacientes/resumo-consulta/${currentRow.id}`;

        return;
      };

      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<IconSecurity />}
          sx={{ textTransform: "none", minWidth: "130px" }}
          onClick={onClick}
        >
          Ver detalhes
        </Button>
      );
    },
  },
];

export const colunasExames = [
  { field: "id", headerName: "Id", width: 0, hide: true },
  {
    field: "tipo",
    headerName: "Exame",
    headerClassName: "color-blue",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "dataCadastro",
    headerName: "Data de solicitação",
    editable: true,
    headerClassName: "color-blue",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "nomeCadastradoPor",
    headerName: "Profissional",
    editable: true,
    headerClassName: "color-blue",
    flex: 2,
    minWidth: 180,
  },
  {
    field: "status",
    headerName: "Data do resultado",
    editable: true,
    headerClassName: "color-blue",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "acoes",
    headerName: "Ações",
    width: 140,
    headerClassName: "color-blue",
    description: "This column has a value getter and is not sortable.",
    renderCell: (params) => {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<IconSecurity />}
          sx={{ textTransform: "none" }}
        >
          Ver detalhes
        </Button>
      );
    },
    sortable: false,
  },
];

export const colunasMedicamentos = [
  { field: "id", headerName: "ID", width: 0, hide: true },
  {
    field: "substancia",
    headerName: "Substância",
    flex: 2,
    headerClassName: "color-blue",
    minWidth: 250,
  },
  {
    field: "medicamento",
    headerName: "Medicamento",
    flex: 2,
    editable: true,
    headerClassName: "color-blue",
    minWidth: 250,
  },
  {
    field: "criadoEm",
    headerName: "Data de prescrição",
    flex: 1,
    editable: true,
    headerClassName: "color-blue",
    minWidth: 130,
  },
  {
    field: "status",
    headerName: "Status",
    description: "This column has a value getter and is not sortable.",
    sortable: false,
    flex: 1,
    headerClassName: "color-blue",
    minWidth: 100,
  },
];

export const styles = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  subtitle: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    marginBottom: "5px",
    marginTop: "10px",
    color: "#063F5E",
    fontFamily: "Ninuto, sans-serif !important",
  },
  card: {
    fontWeight: "800",
    fontSize: "1.4rem",
    lineHeight: "25px",
    marginBottom: "5px",
    marginTop: "10px",
    color: "#1E729F",
  },
  cardSubtitle: {
    fontWeight: "800",
    fontSize: "1rem",
    lineHeight: "25px",
    marginBottom: "5px",
    marginTop: "10px",
    color: "#1E729F",
  },
  diamond: {
    fill: "#1E729F",
  },
};
